import { glyph } from '../../theme/glyph';

export function getControlComponentGlyph(componentId: string) {
  switch (componentId) {
    case 'button':
      return glyph.capabilityTab.button;
    case 'slider':
      return glyph.capabilityTab.slider;
    case 'toggle':
      return glyph.capabilityTab.onOff;
    case 'sensor':
      return glyph.capabilityTab.sensor;
    case 'ternary':
      return glyph.capabilityTab.ternary;
    case 'picker':
      return glyph.capabilityTab.picker;
    case 'color':
      return glyph.capabilityTab.color;
    case 'battery':
      return glyph.capabilityTab.battery;
    case 'thermostat':
      return glyph.capabilityTab.thermostat;
    case 'media':
      return glyph.capabilityTab.music;
    case 'camera':
      return glyph.capabilityTab.camera;
    case 'timeline':
      return glyph.capabilityTab.timeline;
    case 'flows':
      return glyph.capabilityTab.flows;
    default:
      return null;
  }
}
